// extracted by mini-css-extract-plugin
module.exports = {"category":"_4071","tabs":"_12234","more":"_9199","morePopupMask":"_12039","morePopup":"_1228","title":"_18563","content":"_15271","item":"_18771","close":"_3814","icon":"_7839"};